import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResearchPortalMainComponent } from './research-portal-main/research-portal-main.component';
import { RouterModule } from '@angular/router';
import { researchPortalRouting } from './research-portal.routing';
import { SharedModule } from '../../shared/shared.module';
import { SectorsComponent } from './sectors/sectors.component';
import { DropDownListModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { SectorValuationMetricsComponent } from './sector-valuation-metrics/sector-valuation-metrics.component';
import { StocksComponent } from './stocks/stocks.components';
import { AddToWatchlistComponent } from './shared/add-to-watchlist/add-to-watchlist.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { StockOverviewComponent } from './stocks/stock-overview/stock-overview.component';
import { RsiGraphComponent } from './stocks/rsi-graph/rsi-graph.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { UtilsModule } from '../../utils/utils.module';
import { HistoricalDataComponent } from './stocks/historical-data/historical-data.component';
import { DisclaimerComponent } from './shared/disclaimer/disclaimer.component';
import { DisclaimerGuard } from './shared/disclaimer-guard';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ClickOutsideModule } from 'ng-click-outside';
import { ServicesModule } from '../../services/services.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [
    ResearchPortalMainComponent,
    SectorsComponent,
    SectorValuationMetricsComponent,
    StocksComponent,
    AddToWatchlistComponent,
    StockOverviewComponent,
    RsiGraphComponent,
    HistoricalDataComponent,
    DisclaimerComponent,
  ],
  imports: [
    CommonModule,
    ServicesModule,
    RouterModule.forChild(researchPortalRouting),
    SharedModule,
    NgApexchartsModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    DropDownsModule,
    DropDownListModule,
    BsDatepickerModule.forRoot(),
    GridModule,
    LayoutModule,
    InputsModule,
    PopupModule,
    ClickOutsideModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
  ],
  providers: [DisclaimerGuard],
})
export class ResearchPortalModule {}
